import PropTypes from "prop-types";
import React from "react";

const Slide = ({ slide, numSlides, index, isSelected }) => {
  return (
    <div
      className="row slide-wrapper"
      role="group"
      aria-label={`slide ${index + 1} of ${numSlides}`}
    >
      <div className="col-xs-16 col-sm-16 iframeHolder">
        {isSelected ? (
          <iframe
            src={slide.videoUrl}
            frameBorder="0"
            allowFullScreen={true}
            title="our advantage video"
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

Slide.propTypes = {
  slide: PropTypes.object.isRequired,
};

export default Slide;



// WEBPACK FOOTER //
// ./src/components/our-advantage/slide.js